import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./client";

function ReactQueryProvider(props) {
  const { children } = props;
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}

export default ReactQueryProvider;
